module.exports = " <header class=header id=not-found> <section class=container> <div transition=fade> <img class=img src=/static/img/tempd.png alt=TEMPd title=TEMPd> <h1 class=title>TEMPd</h1> <p class=description> Looks like the file you were looking for is already gone! </p> </div> </section> </header> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFoundView.vue
 ** module id = 120
 ** module chunks = 2
 **/